















import { Component, Prop, Vue } from 'vue-property-decorator';
import { countBy } from 'lodash';

@Component({
  components: {},
})
export default class OddsTable extends Vue {
  @Prop({ type: String })
  label!: string;

  @Prop({ type: Array, required: true })
  odds!: Array<{
    name: string;
    additionalKey: string;
    quantity: string | number;
    odds: number;
  }>;

  get sortedOdds() {
    return this.odds.sort((a, b) => b.odds - a.odds);
  }

  get nameCount() {
    return countBy(this.odds, 'name');
  }

  getOddsDisplayName({
    name,
    quantity,
    additionalKey,
  }: {
    name: string;
    additionalKey: string;
    quantity: string | number;
  }) {
    const formattedName =
      this.nameCount[name] > 1 && additionalKey !== 'none'
        ? `${name} (${additionalKey})`
        : name;

    if (Number(quantity) === 1) {
      return formattedName;
    }

    return `${formattedName} x${quantity}`;
  }

  getOddsPercentage({ odds }: { odds: number }) {
    const percentage = this.$toLocaleString(odds * 100, {
      maxDigits: odds < 0.00001 ? 4 : 2,
      minDigits: 2,
    });
    return `${percentage}%`;
  }
}
